import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { enumText, formatDateToPtbr, getUserNameToName, translate } from '../../../../utils/util';
import ContainerService from '../../../../services/ContainerService';
import { Breadcrumbs, Button, Collapsible, Input, Table } from '../../../../components/UI/ComponentsUI';
import { onValueChange } from '../../../../utils/handleChangeHooks';
import * as containerAction from '../../../../actions/containerAction';
import { ENUMS } from '../../../../utils/constants';

const CoveragePartNumberList = (props) => {
    const [currentPage, setCurrentPage] = useState({ pageSize: 10, pageIndex: 0, sortField: "", sortOrder: 0 });
    const [data, setData] = useState([]);
    const [filter, setFilter] = useState({});

    useEffect(() => {
        if (props.coveragePartNumberPaged?.items) {
            setData(props.coveragePartNumberPaged.items || []);
        }
        // eslint-disable-next-line
    }, [props?.coveragePartNumberPaged?.items]);

    useEffect(() => {
        onSearch(false);
        // eslint-disable-next-line
    }, [currentPage]);

    const onSearch = (click) => {
        props.getPaged({
            ...filter,
            sortField: currentPage.sortField,
            sortOrder: currentPage.sortOrder,
            PageSize: currentPage.pageSize,
            PageIndex: click ? 0 : currentPage.pageIndex
        });
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const onSelectItemChange = (coveragePartNumber) => {
        props.setCoveragePartNumber(coveragePartNumber);
        props.history.push({
            pathname: '../partnumber/insert',
            state: { update: true }

        });
    };

    const configColumn = () => {
        const cols = [
            {
                field: 'id',
                header: "Id",
                align: 'left',
                sortable: false
            },
            {
                field: 'code',
                header: 'Código',
                align: 'left',
                sortable: true
            }, {
                field: 'description',
                header: 'Descrição',
                align: 'left',
                sortable: true
            },
            {
                field: 'supplierCode',
                header: 'Cod. Appro',
                align: 'left',
                sortable: true
            },
            {
                field: 'supplierName',
                header: 'Nom. Appro.',
                align: 'left',
                sortable: true
            },
            {
                field: 'stockLineBorder',
                header: 'Stock BDL',
                align: 'left',
                sortable: true
            },
            {
                field: 'hourLineBorder',
                header: 'Hora BDL',
                body: (rowData) => rowData.hourLineBorder.substring(0, 5),
                align: 'left',
                sortable: true
            },
            {
                field: 'balanceLineBorder',
                header: 'Saldo BDL',
                align: 'left',
                sortable: true
            },
            {
                field: 'coverage',
                header: 'Cobertura',
                align: 'left',
                sortable: true
            },
            {
                field: 'lineBorder',
                header: 'BDL',
                body: (rowData) => enumText(ENUMS.eLineBorder, rowData.lineBorder),
                align: 'left',
                sortable: true
            },
            {
                field: 'lineBorderType',
                header: 'Tipo BDL',
                body: (rowData) => enumText(ENUMS.eLineBorderType, rowData.lineBorderType),
                align: 'left',
                sortable: true
            },
            {
                field: 'pgm',
                header: 'PGM',
                body: (rowData) => rowData.pgm && <i className="material-icons sixth-text-color"
                    style={{ fontSize: '1.85rem', cursor: 'pointer', color: 'green' }}>done</i>,
                align: 'left',
                sortable: true
            },
            {
                field: 'automaticLow',
                body: (rowData) => rowData.automaticLow && <i className="material-icons sixth-text-color"
                    style={{ fontSize: '1.85rem', cursor: 'pointer', color: 'green' }}>done</i>,
                header: 'Baixa Aut.',
                align: 'left',
                sortable: true
            },
            {
                field: 'partsSensible',
                header: 'Pça. Sensivel',
                body: (rowData) => rowData.partsSensible && <i className="material-icons sixth-text-color"
                    style={{ fontSize: '1.85rem', cursor: 'pointer', color: 'green' }}>done</i>,
                align: 'left',
                sortable: true
            },
            {
                field: 'security',
                header: 'Segurança',
                align: 'left',
                sortable: true
            },
            {
                field: 'stockSens',
                header: 'Stock SENS2',
                align: 'left',
                sortable: true
            },
            {
                field: 'finalStock',
                header: 'Stock Final',
                align: 'left',
                sortable: true
            },
            {
                field: 'dock',
                header: 'Fec. Alta',
                body: (rowData) => formatDateToPtbr(rowData.createdOn),
                align: 'left',
                sortable: true
            },
            {
                field: 'createdOn',
                body: (rowData) => formatDateToPtbr(rowData.createdOn),
                header: 'Data Criação',
                align: 'left',
                sortable: true
            },
            {
                field: 'createdBy',
                body: (rowData) => getUserNameToName(props?.usersFromElog, rowData.createdBy),
                header: 'Criado Por',
                align: 'left',
            }
        ];
        return cols;
    };

    const configActions = () => [
        {
            function: (row) => (
                <i className="material-icons sixth-text-color"
                    onClick={() => onSelectItemChange(row)}
                    style={{ fontSize: '1.85rem', cursor: 'pointer', color: 'green' }}>edit</i>
            )
        },
        {
            function: (row) => (
                <i className="material-icons sixth-text-color"
                    onClick={() => props.delete(row.id, () => {
                        onSearch(true)
                    })}
                    style={{ fontSize: '1.85rem', cursor: 'pointer', color: 'red' }}>delete</i>
            )
        }
    ];


    return (
        <div>
            <Breadcrumbs
                title={{ icon: "mdi mdi-view-dashboard-outline", label: "Parametrização do PN" }} />
            <i className={`mdi mdi-36px mdi-sticker-plus above-btn`}
                style={{ cursor: 'pointer' }}
                onClick={() => props.history.push({ pathname: './insert' })} />
            <div className="container-fluid" style={{ marginTop: '40px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <Collapsible
                        id="collapsible2"
                        header={translate('expedition:picking.filter')}
                        body={
                            <>
                                <div className="row">
                                    <div className="input-field no-padding col s6">
                                        <Input
                                            id="code"
                                            name='code'
                                            label="Código"
                                            type="text"
                                            defaultValue={filter?.code || ''}
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            id="description"
                                            name='description'
                                            label="Descrição"
                                            type="text"
                                            defaultValue={filter?.description || ''}
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>
                                <div className="row" style={{ paddingTop: '5px' }}>
                                    <Button full="true" text="Buscar" onClick={() => onSearch(true)} />
                                </div>
                            </>
                        }
                    />
                </div>
                <div id="areaVirtual" className="container-fluid">
                    <Table
                        totalPages={props.coveragePartNumberPaged?.totalPages || 0}
                        current={{ currentPage, setCurrentPage }}
                        col={configColumn()}
                        data={data}
                        actions={configActions()} />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        coveragePartNumberPaged: state.containerReducer.coveragePartNumberPaged,
        usersFromElog: state.usersElogReducer.usersElog
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPaged: (filter) => {
            dispatch(ContainerService.getPagedCoveragePartNumber(filter));
        },
        delete: (id, callback) => {
            dispatch(ContainerService.deleteCoveragePartNumber(id, callback));
        },
        setCoveragePartNumber: (coveragePartNumber) => {
            dispatch(containerAction.setCoveragePartNumber(coveragePartNumber))
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CoveragePartNumberList));